import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { NOT_AVAILABLE, IconNames } from '../../../common/constants';
import { AutoUnsubscribe } from '../../../common/decorators';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { DirectivesModule } from '../../../common/directives/directives.module';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { InfoFieldItemComponent } from '../info-field-item/info-field-item.component';
import { InfoFieldExpandableValueListDirective } from './info-field-expandable-value-list.directive';

@Component({
  selector: 'ui-info-field-expandable-value-list',
  imports: [
    CommonModule,
    MatFormFieldModule,
    TranslateModule,
    PipesModule,
    DirectivesModule,
    SvgIconComponent,
    InfoFieldItemComponent,
    InfoFieldExpandableValueListDirective,
  ],
  templateUrl: './info-field-expandable-value-list.component.html',
  styleUrls: ['./info-field-expandable-value-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class InfoFieldExpandableValueListComponent {
  @Input() label: string | null = null;
  @Input() items: string[] = [];

  readonly notAvailable = NOT_AVAILABLE;
  readonly iconNames = IconNames;

  isOpened$ = new BehaviorSubject<boolean | null>(null);
  fits$ = new BehaviorSubject<boolean | null>(null);

  toggleHeight(): void {
    if (this.fits$.getValue()) {
      return;
    }

    if (this.isOpened$.getValue() === null) {
      this.isOpened$.next(true);

      return;
    }

    this.isOpened$.next(!this.isOpened$.getValue());
  }

  onFitEvent(event: boolean): void {
    this.fits$.next(event);
  }
}
